import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { PDialogFooterBtnActionType } from '@frontend-site/ui/components';
import { LONG_REQUEST_STATUSES, RequestStatusInfo, RequestStatusService } from '@frontend-site/main-header/domain';
import { TranslateService } from '@ngx-translate/core';
import { ColDef } from '@ag-grid-community/core';
import { RequestStatusCellRendererComponent } from './request-status-renderer/request-status-cell-renderer/request-status-cell-renderer.component';
import { compareDatetime } from '@frontend-site/shared/utils';
import { getFormattedDateIncludesTimeForGrid } from '@frontend-site/grid/grid-utils';

@Component({
    selector: 'p-request-status-dialog',
    templateUrl: './request-status-dialog.component.html',
    styleUrls: ['./request-status-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [RequestStatusService]
})
export class RequestStatusDialogComponent {
    @HostBinding('attr.automation-id') automationId = 'popup-request-status';

    frameworkComponents = {
        requestStatusRenderer: RequestStatusCellRendererComponent
    };

    gridOptions = {
        rowGroupPanelShow: 'never',
        suppressRowClickSelection: true
    };
    defaultColDef: ColDef = {
        sortable: true
    };
    columns: ColDef[] = [
        {
            headerName: this.translate.instant('longRequestCenter.requestDetails'),
            field: 'requestDetails',
            width: 200,
            flex: 1,
            filter: 'agTextColumnFilter',
            enableRowGroup: false,
            resizable: false
        },
        {
            headerName: this.translate.instant('longRequestCenter.creationDate'),
            field: 'creationDate',
            width: 150,
            enableRowGroup: false,
            valueFormatter: (params) => getFormattedDateIncludesTimeForGrid(params.data.creationDate),
            filterParams: { comparator: compareDatetime, inRangeInclusive: true },
            filter: 'agDateColumnFilter'
        },
        {
            headerName: this.translate.instant('longRequestCenter.requestNumber'),
            field: 'requestNumber',
            width: 180,
            filter: 'agNumberColumnFilter',
            enableRowGroup: false
        },
        {
            headerName: this.translate.instant('longRequestCenter.status'),
            field: 'status',
            width: 230,
            cellRenderer: 'requestStatusRenderer',
            filter: 'agSetColumnFilter',
            filterParams: { values: LONG_REQUEST_STATUSES },
            enableRowGroup: false
        }
    ];

    rowNodeId: (row: RequestStatusInfo) => string = (row) => row.requestNumber?.toString();

    rows$ = this.requestStatusService.rows$;

    constructor(private translate: TranslateService, private requestStatusService: RequestStatusService) {}

    get footerConfig(): { text: string; type?: PDialogFooterBtnActionType; click?: () => void }[] {
        return [
            {
                text: 'Actions.close',
                type: PDialogFooterBtnActionType.Close
            }
        ];
    }
}
